module.exports = __webpack_public_path__ + "img/atlas_logo_gray.f507eaee.png";